import { LoadingSkeleton } from '@eventbrite/timed-entry';
import React from 'react';

import { Stack } from '@eventbrite/marmalade';
import styles from './TicketsAccordionLoadingSkeleton.module.scss';

export const TicketsAccordionLoadingSkeleton = () => {
    return (
        <Stack space="spacing-md" className={styles.container}>
            <LoadingSkeleton skeletonMinHeight={{ unit: 'px', value: 72 }} />
            <LoadingSkeleton skeletonMinHeight={{ unit: 'px', value: 300 }} />
            <LoadingSkeleton skeletonMinHeight={{ unit: 'px', value: 300 }} />
        </Stack>
    );
};
